export default {"src":"/_next/static/media/curation_3.17ad2793.gif","height":500,"width":550,"blurWidth":0,"blurHeight":0};